import { Controller } from "@hotwired/stimulus"
import { format } from "date-fns"

// Connects to data-controller="joblines"
export default class extends Controller {

  static values = {
    joblog: String
  };

  connect() {
    this.afterId = '0';
    this.linesLimit = 100;

    // console.log("Connected to joblines controller", this.element);
    // console.log("Joblog id is ", this.joblogValue);

    this.linesElement = this.element.querySelector("#lines");
    this.loaderElement = this.element.querySelector("#loader");

    this.fetchSomeLines();
  }

  fetchSomeLines() {
    const url = `/joblogs/${this.joblogValue}/joblines.json?after_id=${this.afterId}&limit=${this.linesLimit}`;

    // console.log("Fetching from URL ", url);

    fetch(url)
      .then((response) => {
        // console.log("got success from fetching lines");
        // console.log(response);
        return response.json();
      })
      .then((linesJson) => {
        // console.log("processing lines JSON");
        // console.log(linesJson);
        this.appendLines(linesJson);
      })
      .catch((error) => {
        // console.log("error fetching lines");
        // console.log(error);
        this.afterId = '0';
        this.clearAllLines("(error)");
        this.fetchSomeLinesLater(0, false);
      })
  }

  appendLines(result) {
    // console.log("Append lines");

    if (this.afterId == '0') {
      this.linesElement.textContent = "";
    }

    var lines = result['joblines'];

    var formattedLines = lines?.map(function (lineJson) {
      var utcDT = lineJson['created_at']
      const date = new Date(utcDT); // this converts to a Date in *local* timezone
      const localDTStr = format(date, "yyyy-MM-dd HH:mm:ss");
      return localDTStr + ' - ' + lineJson['line'] + '\n';
    })

    if (formattedLines) {
      const pre = document.createElement("pre")
      pre.classList.add("joblog-lines-content")
      pre.textContent = formattedLines.join('')

      // Append it to the container
      this.linesElement.appendChild(pre)
    }

    if (lines?.length > 0) {
      this.afterId = lines[lines.length - 1]['id'];
    }

    this.fetchSomeLinesLater(lines?.length || 0, result['completed']);
  }

  fetchSomeLinesLater(numLinesJustFetched, completed) {
    if (this.element == undefined) {
      // console.log('No element for joblog ' + this.joblogId + ', so not requesting lines later');
      return;
    }

    if (!completed || numLinesJustFetched > 0) {
      setTimeout(function () {
        this.fetchSomeLines();
      }.bind(this), numLinesJustFetched == 0 ? 2000 : 100);
    }
    else {
      this.loaderElement.hidden = true;
      // console.log("Job is complete, not fetching any more lines");
    }
  }

  clearAllLines(text) {
    this.linesElement.textContent = text || "";
  }
}
